import { render, staticRenderFns } from "./XsltTemplate.vue?vue&type=template&id=47f631c4&scoped=true"
import script from "./XsltTemplate.vue?vue&type=script&lang=js"
export * from "./XsltTemplate.vue?vue&type=script&lang=js"
import style0 from "./XsltTemplate.vue?vue&type=style&index=0&id=47f631c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f631c4",
  null
  
)

export default component.exports